export default __webpack_public_path__ + "static/media/feature1.71f8de92.jpg";